import type { DateOrRange } from '@/infrastructure/departure-date/store'
import * as React from 'react'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { DepartureDateFilterComponent } from '@/scopes/search/components/DepartureDateFilter'
import { useDepartureDateFilter } from '@/scopes/search/components/DepartureDateFilter/hooks'
import { createSearchFilterClickEvent } from '@/scopes/search/search/domain/analytics'
import { useMultiSelectFilter } from '@/scopes/search/search/domain/hooks'
import { QuickSearchFilterProps } from '@/scopes/search/search/pages/SearchPage/components/QuickSearchFilters/types'
import { useSearchDependencies } from '@/scopes/search/search/pages/SearchPage/context'

export function DepartureDateQuickSearchItemFilter({ id, asSheet }: QuickSearchFilterProps) {
  const { options, isFetching } = useMultiSelectFilter('DepartureDate')
  const { resetDepartureDate } = useDepartureDateFilter({ options })
  const { sendEvent } = useAnalytics()
  const { dateFilterActions: selectDepartureDateActions } = useSearchDependencies()

  function handleConfirm({ departureDate }: { departureDate: DateOrRange }) {
    selectDepartureDateActions.setDepartureDateFilterSelection(departureDate)
    sendEvent(
      createSearchFilterClickEvent({
        element: 'calendar',
        type: 'departure date',
        result: Array.isArray(departureDate) ? departureDate.join(' ') : departureDate,
      }),
    )
  }

  function handleReset() {
    resetDepartureDate()
  }

  return (
    <DepartureDateFilterComponent
      onConfirm={handleConfirm}
      onReset={handleReset}
      disabled={isFetching}
      options={options}
      id={id}
      asSheet={asSheet}
    />
  )
}
